var angular = require('angular');

var mod =  angular.module("app.directives")

mod.factory('TwitterService', ['$timeout', function ($timeout) {
    return {
        load: function () {
        if (typeof twttr === 'undefined') {
            (function() {
                !function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0],p=/^http:/.test(d.location)?'http':'https';if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src=p+'://platform.twitter.com/widgets.js';fjs.parentNode.insertBefore(js,fjs);}}(document, 'script', 'twitter-wjs');
            })();
        } else {
            $timeout(function(){
              twttr.widgets.load();
            })
        };
        }
    }
}])


mod.directive('timeline', function (TwitterService) {
  return {
    restrict: 'E',
    scope: {
      username: "=",
    },
    template: '<div class="twitter-timeline-directive"><a></a></div>',
    replace: true,
    link: function (scope, element, attrs) {

      scope.build = function(){
        var el = angular.element('<a class="twitter-timeline" data-width="400" data-height="600"></a>');
        el.attr("href", "https://twitter.com/" + scope.username);
        element.children().eq(0).replaceWith(el);
      }

      scope.$watch('username', function(val){
        if (scope.exists) {
          element.children().eq(0).remove();
        }
        if (!val) return;
        scope.exists = true;
        scope.build()
        scope.$evalAsync(function(){
          TwitterService.load();
        })
      })
    }
  }
})
